import { render, staticRenderFns } from "./125.vue?vue&type=template&id=4b9d7a64&scoped=true&"
var script = {}
import style0 from "./125.vue?vue&type=style&index=0&id=4b9d7a64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9d7a64",
  null
  
)

export default component.exports